import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
export function Guarantee() {
  useTrackSection('guarantee', 'Guarantee Section');
  return <section id="guarantee" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(235,248,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-163">
      <div className="mx-auto max-w-3xl" data-id="element-164">
        {/* Card */}
        <div className="rounded-2xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(0,119,182,0.30)'
      }} data-id="element-165">
          {/* Header */}
          <div className="px-6 py-5 text-center" style={{
          background: 'linear-gradient(135deg, rgb(0,96,145), rgb(0,119,182))'
        }} data-id="element-166">
            <div className="text-5xl mb-3" data-id="element-167">🛡️</div>
            <h2 className="text-xl sm:text-2xl font-black text-white m-0" data-id="element-168">
              GARANTÍA MEGAPACK™ — 7 DÍAS
            </h2>
          </div>

          {/* Body */}
          <div className="px-6 py-6 text-center" style={{
          backgroundColor: 'rgba(0,119,182,0.05)'
        }} data-id="element-169">
            <p className="text-sm text-gray-600 m-0 mb-2" data-id="element-170">
              Abrís los 6 tomos. Revisás los 6 bonos. Los usás en sesión si
              querés.
            </p>
            <p className="text-sm text-gray-600 m-0 mb-5" data-id="element-171">
              Si en 7 días no es lo que esperabas:
            </p>

            <p className="text-3xl font-black m-0 mb-3" style={{
            color: '#0077B6'
          }} data-id="element-172">
              Te devolvemos el 100%.
            </p>
            <p className="text-base font-black text-gray-900 m-0" data-id="element-173">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 text-center border-t" style={{
          backgroundColor: 'rgb(255,255,255)',
          borderColor: 'rgba(0,119,182,0.15)'
        }} data-id="element-174">
            <p className="text-xs text-gray-500 m-0 leading-5" data-id="element-175">
              La confianza que tenemos en el Megapack Kinesiología Resuelta nos
              permite hacer esa promesa sin dudar.
              <br data-id="element-176" />
              Más de 400 kinesiólogos de todo el país ya lo saben.
              <br data-id="element-177" />
              La tasa de devoluciones es menor al 1%.
            </p>
          </div>
        </div>
      </div>
    </section>;
}